export const ShapeTypes = {
    CIRCLE: 'circle',
    LINE: 'line',
    POLYGON: 'polygon',
}

export function getRadius(shape) {
    if (shape.type === ShapeTypes.CIRCLE) {
        return shape.points[0].radius
    }

    return 0
}

export function getAllLatLongsForShape(shape) {
    const bounds = shape.points.map((p) => [Number(p.latitude), Number(p.longitude)])

    // A circle has only one point, so we need to add some fake ones to account for its radius
    // Quick & dirty meters => lat/lng conversation from https://bit.ly/3ea2wPG
    if (shape.type === ShapeTypes.CIRCLE) {
        const radius = getRadius(shape)
        const radiusLat = radius / 111111
        const radiusLng = (radius / 111111) * Math.cos(radiusLat)
        const [centerLat, centerLng] = bounds[0]
        bounds.push([centerLat + radiusLat, centerLng + radiusLng])
        bounds.push([centerLat - radiusLat, centerLng - radiusLng])
    }

    return bounds
}

export function getPolygonPoints(shape) {
    return shape.points.map((p) => [p.latitude, p.longitude])
}

export function getAllLatLongs(mapObject) {
    return [[mapObject.latitude, mapObject.longitude]]
}

export function getLatLong(mapObject) {
    return [mapObject.latitude, mapObject.longitude]
}

export function getLabelForUserLocation({ user }) {
    if (user.callsign) {
        return user.callsign
    }

    return user.user ? user.user.name : user.gid
}

export function getUserIcon(user) {
    const { icon, stale, inactive } = user.settings
    return !stale && !inactive ? icon : `${icon}-stale`
}

// converts mobile colors to match portal icon picker colors since mobile colors
// are currently different from portal
const mobileToPortalColors = {
    '#ef4b22': 'red',
    '#ff00ff': 'purple',
    '#eccb6d': 'yellow',
    '#008200': 'green',
    '#4a90e2': 'blue',
}
export function getShapeIcon(shape) {
    const { type, color } = shape
    const portalColor = mobileToPortalColors[color.toLowerCase()] || 'default'

    return `shape-${type}-${portalColor}`
}
